import { HashRouter, Route, Routes, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { ProgressProvider } from './hooks/useProgress';
import { Footer, Nav } from './components/Layout';
import Home from './pages/Home';
import Courses from './pages/Courses';
import CoursePage from './pages/CoursePage';
import LessonPage from './pages/LessonPage';
import CheatSheet from './pages/CheatSheet';
import NotFound from './pages/NotFound';

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// HashRouter keeps every route working on any static host, no server rewrites needed.
export default function App() {
  return (
    <MotionConfig reducedMotion="user">
      <ProgressProvider>
        <HashRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <ScrollTop />
          <div className="aurora" aria-hidden="true"><i /><i /><i /></div>
          <Nav />
          <main className="main">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/courses" element={<Courses />} />
              <Route path="/cheatsheet" element={<CheatSheet />} />
              <Route path="/course/:courseId" element={<CoursePage />} />
              <Route path="/course/:courseId/:lessonId" element={<LessonPage />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </HashRouter>
      </ProgressProvider>
    </MotionConfig>
  );
}
